import { Blog } from "../components/Blog";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import Navbar from "../components/Navbar";
import Services from "../components/Services";
import Testimonials from "../components/Testimonials";
import Welcome from "../components/Welcome";

function Home() {
  return (
    <div>
      <Navbar />
      <Hero />
      <Welcome />
      <Services />
      <Testimonials />
      <Blog slice={3} />
      <Footer />
    </div>
  );
}

export default Home;
